(function() {
  var roots = Array.prototype.slice.call(document.querySelectorAll('[data-about-history]'));

  roots.forEach(function(root) {
    if (root.dataset.manualCarouselReady === 'true') return;
    root.dataset.manualCarouselReady = 'true';

    var viewport = root.querySelector('[data-history-viewport]');
    var track = root.querySelector('[data-history-track]');
    var items = Array.prototype.slice.call(root.querySelectorAll('[data-history-item]'));
    var descriptions = Array.prototype.slice.call(root.querySelectorAll('.firefly-about-history__description'));
    var previous = root.querySelector('[data-history-prev]');
    var next = root.querySelector('[data-history-next]');
    if (!viewport || !track || !items.length || !previous || !next) return;

    var activeIndex = 0;
    var ticking = false;
    var alignmentFrame = 0;

    function alignDescriptions() {
      if (!descriptions.length) return;
      descriptions.forEach(function(description) {
        description.style.minHeight = '';
      });
      if (!window.matchMedia('(min-width: 768px)').matches) return;

      var maximumHeight = descriptions.reduce(function(maximum, description) {
        return Math.max(maximum, description.offsetHeight);
      }, 0);

      descriptions.forEach(function(description) {
        description.style.minHeight = maximumHeight + 'px';
      });
    }

    function scheduleDescriptionAlignment() {
      if (alignmentFrame) window.cancelAnimationFrame(alignmentFrame);
      alignmentFrame = window.requestAnimationFrame(function() {
        alignmentFrame = 0;
        alignDescriptions();
      });
    }

    function itemOffset(index) {
      return items[index].offsetLeft - (parseFloat(getComputedStyle(track).paddingLeft) || 0);
    }

    function updateActive(index) {
      activeIndex = Math.max(0, Math.min(items.length - 1, index));
      items.forEach(function(item, itemIndex) {
        item.classList.toggle('is-active', itemIndex === activeIndex);
      });
      previous.disabled = activeIndex === 0;
      next.disabled = activeIndex === items.length - 1;
    }

    function nearestIndex() {
      var viewportLeft = viewport.getBoundingClientRect().left + (parseFloat(getComputedStyle(track).paddingLeft) || 0);
      var closestIndex = 0;
      var closestDistance = Infinity;

      items.forEach(function(item, index) {
        var distance = Math.abs(item.getBoundingClientRect().left - viewportLeft);
        if (distance < closestDistance) {
          closestDistance = distance;
          closestIndex = index;
        }
      });

      return closestIndex;
    }

    function scrollToIndex(index) {
      var targetIndex = Math.max(0, Math.min(items.length - 1, index));
      viewport.scrollTo({ left: itemOffset(targetIndex), behavior: 'smooth' });
      updateActive(targetIndex);
    }

    previous.addEventListener('click', function() {
      scrollToIndex(activeIndex - 1);
    });

    next.addEventListener('click', function() {
      scrollToIndex(activeIndex + 1);
    });

    viewport.addEventListener('scroll', function() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function() {
        ticking = false;
        updateActive(nearestIndex());
      });
    }, { passive: true });

    window.addEventListener('resize', scheduleDescriptionAlignment);
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(scheduleDescriptionAlignment);
    }
    window.addEventListener('load', scheduleDescriptionAlignment, { once: true });

    alignDescriptions();
    updateActive(0);
  });
})();
